module.exports = __webpack_public_path__ + "img/video_icon08.c9e3486c.png";